import React, { useEffect } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import Switcher from "../components/switcher";
import Productos from "../components/Productos";
import InsuranceProcess from "../components/InsuranceProcess";
import cargo from "../assets/images/sidom/fotos/insurance/bannerCard-Insurance1.png";
import Containers from "../assets/images/sidom/fotos/insurance/bannerCard-Insurance2.png";
import Surety from "../assets/images/sidom/fotos/insurance/bannerCard-Insurance3.png";
import Risk from "../assets/images/sidom/fotos/insurance/bannerCard-Insurance4.png";
import Stock from "../assets/images/sidom/fotos/insurance/bannerCard-Insurance5.png";
import Soporte from "../assets/images/sidom/fotos/insurance/bannerCard-Insurance6.png";
import imgD from "../assets/images/sidom/fotos/insurance/svg/Recurso 61insurance.svg";
import imgDd from "../assets/images/sidom/fotos/insurance/svg/Recurso 59insurance.svg";
import VideoBackground from "../components/VideoBackground";

import CardBeneficios from "../components/CardBeneficios";
import PortalAutogestion from "../components/PortalAutogestion";
import useStore from "../store/useStore";
import Seo from "../components/Seo";

const steps1 = [
  "Despachante recibe el requerimiento por parte de la aduana y una cotización por el seguro de Caución solicitado.",
  "El Despachante genera la solicitud desde el sistema MiSIM  para que se emita la Caución. El despachante puede contratar en nombre del cliente o involucrar al Broker y al Importador.",
  "La Aseguradora emite la póliza.",
  "El Despachante afecta la póliza de caución.",
  "Mercadería liberada por Aduana.",
];
const steps2 = [
  "Se necesita mover mercadería de un Punto A a un Punto B.",
  "Surge la necesidad y el requerimiento de contratar un seguro que las proteja de los riesgos inherentes al transporte.",
  "Desde MiSIM el usuario puede cotizar el seguro para la mercadería, de acuerdo a las condiciones de la póliza flotante.",
  "Contrata el seguro, con una emisión en tiempo real de la póliza avalada por la aseguradora, teniendo cobertura desde ese momento.",
];
const productos = [
  {
    title: "Cargo",
    description:
      "Optimizamos procesos, logrando mitigar riesgos en las operaciones logísticas de transporte marítimo, aéreo y terrestre. Brindamos cotizaciones en el acto, evitando las pérdidas de tiempo.",
    img: cargo,
  },
  {
    title: "Containers",
    description:
      "Nuestra tecnología ofrece una solución integral y sin complicaciones para contratar seguros de contenedores, garantizando su estado óptimo y devolución puntual.",
    img: Containers,
  },
  {
    title: "Surety",
    description:
      "Diseñamos un producto que permite a nuestros clientes ofrecer garantías ininterrumpidas las 24 horas, los 7 días de la semana, con las condiciones más favorables.",
    img: Surety,
  },
  {
    title: "Risk-Management",
    description:
      "Agilizamos los procesos en el gerenciamiento de riesgo, trabajando con partners líderes en la región y garantizando la seguridad para mover tu mercadería o la de tus clientes.",
    img: Risk,
  },
  {
    title: "Stock",
    description:
      "Contamos con un equipo capacitado para dar soporte e identificar oportunidades de mejora y desarrollo de nuevas coberturas. La obsesión por la excelencia marca el norte.",
    img: Stock,
  },
  {
    title: "Soporte y Conocimiento",
    description:
      "Contamos con un equipo capacitado para dar soporte e identificar oportunidades de mejora y desarrollo de nuevas coberturas.",
    img: Soporte,
  },
];

const productos2 = [
  {
    title: "Amplia oferta de Coberturas",
    description:
      "Contamos con el ecosistema de soluciones necesarias para cubrir todas las necesidades de las operaciones de comercio internacional.",
  },
  {
    title: "Automatización del Proceso",
    description:
      "Cotización y contratación de seguros en 5 simples pasos, permitiendo comparar múltiples ofertas de seguros y con información a tiempo real.",
  },
  {
    title: "Costos mejorados",
    description:
      "Nuestro objetivo es lograr un mercado más transparente para todos los actores, es por eso que nuestros servicios tienen un pricing simple y sin costos ocultos.",
  },
  {
    title: "Personalización",
    description:
      "Customizamos nuestras soluciones y los productos tradicionales de la industria para adaptarlos a las necesidades de los clientes. ",
  },
];

// Página de Insurance principal
export default function SidomInsurance() {
  const { insurances, getHeroInsurances, seoInsurances, fetchSeoInsurances } =
    useStore();

  const urlApi = process.env.REACT_APP_STRAPI_URL;

  useEffect(() => {
    getHeroInsurances();
    fetchSeoInsurances();
  }, [getHeroInsurances, fetchSeoInsurances]);

  return (
    <div>
      <Seo
        metaTitle={seoInsurances[0]?.metatitle}
        metaDescription={seoInsurances[0]?.metadescription}
        metaImage={seoInsurances[0]?.metaimage?.url}
        metaKeywords={seoInsurances[0]?.metakeywords}
        canonicalURL={seoInsurances[0]?.canonicalurl}
      />
      <header>
        <Navbar tabIndex={0} aria-label="Navegación principal" />
      </header>
      {/* Sección principal de Insurance */}
      <section
        aria-label="Información sobre Insurance SIDOM"
        className="bg-sidom-light dark:bg-sidom-blue"
      >
        {insurances?.length === 0 || !insurances ? (
          <VideoBackground
            video="/placeholder.mp4"
            titulo1="Cargando..."
            titulo2="Espere un momento"
            textbutton="SOLICITAR DEMO"
            logo="/placeholder-logo.png"
            tabIndex={0}
            aria-label="Video de carga"
          />
        ) : (
          insurances.map((item, index) => (
            <VideoBackground
              key={index}
              video={`${urlApi}${item.video[0]?.url}`}
              titulo1={item.titulo}
              titulo2={item.text}
              textbutton="SOLICITAR DEMO"
              link="/contact"
              logo={`${urlApi}${
                item.img[0]?.formats?.thumbnail?.url ||
                item.img?.url ||
                "/placeholder-logo.png"
              }`}
              tabIndex={0}
              aria-label={`Video de ${item.titulo}`}
            />
          ))
        )}

        {/* Sección Portal de Autogestión */}
        <section className="container ">
          <PortalAutogestion />
        </section>

        <section
          className=" container mb-[70px] md:mb-[100px] lg:mb-[90px]"
          tabIndex={0}
          aria-label="Productos de SIDOM Insurance"
        >
          <div className="px-2 md:px-0 ">
            <Productos
              productos={productos}
              tabIndex={0}
              aria-label="Lista de productos"
            />
          </div>
        </section>

        <section
          className="mb-[70px] md:mb-[100px] lg:mb-[90px] bg-sidom-blue flex flex-col h-full"
          tabIndex={0}
          aria-label="Procesos de Insurance"
        >
          <div className="container mt-[70px] md:mt-[100px] lg:mt-[90px]">
            <InsuranceProcess
              title="Cotización y contratación de <strong> póliza de Caución Aduanera </strong> con"
              subtitle="SIDOM Insurance"
              imageD={imgD}
              steps={steps1}
              tabIndex={0}
              aria-label="Proceso de Caución Aduanera"
            />
          </div>
          <div className="container">
            <InsuranceProcess
              title="Cotización y contratación de <strong> póliza de Certificado de Carga </strong> con"
              subtitle="SIDOM Insurance"
              imageD={imgDd}
              steps={steps2}
              tabIndex={0}
              aria-label="Proceso de Certificado de Carga"
            />
          </div>
        </section>

        <section
          className="mt-[70px] md:mt-[100px] lg:mt-[90px] container flex flex-col h-full"
          tabIndex={0}
          aria-label="Beneficios de SIDOM Insurance"
        >
          <h1
            className="text-sidom-orange text-3xl md:text-[40px]/ lg:text-[45px] leading-tight font-extrabold text-left mb-[60px]"
            tabIndex={0}
            aria-label="Título: Beneficios"
          >
            Beneficios
          </h1>
          <div className="mb-[70px] md:mb-[100px] lg:mb-[90px]">
            {productos2.map((producto, index) => (
              <CardBeneficios
                key={index}
                titulo={producto.title}
                descripcion={producto.description}
                tabIndex={0}
                aria-label={`Beneficio: ${producto.title}`}
              />
            ))}
          </div>
        </section>
      </section>
      {/* Footer y switcher de tema */}
      <Footer tabIndex={0} aria-label="Pie de página" />
      <Switcher tabIndex={0} aria-label="Botón para cambiar tema" />
    </div>
  );
}
